function getFontSize(): string {
    if (window.screen.width < 800) {
        return "fa-2x";
    }
    else {
        return "fa-1x";
    }
}

function getSocialData() {
    var fontSize = getFontSize();
    return {
        socialIcons: [{
            id: "facebook",
            url: "https://www.facebook.com/wesaltythree",
            icon: ["fab", "facebook-square"],
            fontClass: fontSize
        }, {
            id: "youtube",
            url: "https://www.youtube.com/channel/UCB5rsGG7OQgWRLbygls0jKQ",
            icon: ["fab", "youtube-square"],
            fontClass: fontSize
        }, {
            id: "twitter",
            url: "https://www.twitter.com/wesaltythree",
            icon: ["fab", "twitter-square"],
            fontClass: fontSize
        }, {
            id: "instagram",
            url: "https://instagram.com/wesaltythree",
            icon: ["fab", "instagram"],
            fontClass: fontSize
        }]
    };
}

export { getSocialData, getFontSize }